import { FC, memo } from 'react'

import { useGetTetrisCategoryData } from '../../hooks'
import { random } from '../../utils/random'
import CategoryCard, { CategoryProp } from './categoryCard'

import './categoryTetris.css'
type Props = {
  categories?: CategoryProp[]
  className?: string
}

const CategoryTetris: FC<Props> = (props) => {
  const layout = random(4, 1)
  let wideCount = random(2)
  let squareCount = random(2)
  const categories = useGetTetrisCategoryData()
  return (
    <div className={'categories layout' + layout}>
      {(props.categories || categories).map((category, ci) => {
        return !ci ? (
          <CategoryCard key={ci} {...category} className={'tall'} />
        ) : ci < 3 ? (
          <CategoryCard key={ci} {...category} className={`wide${(wideCount++ % 2) + 1}`} />
        ) : (
          <CategoryCard key={ci} {...category} className={`square${(squareCount++ % 2) + 1}`} />
        )
      })}
    </div>
  )
}

export default memo(CategoryTetris)
